export interface DeviceInfo {
  isSamsungBrowser: boolean;
  isSamsungDevice: boolean;
  model: string;
  androidVersion: string;
  oneUIVersion: string;
}

/**
 * Estrae informazioni principali dal user agent.
 * Utilizzato per debug su dispositivi mobili.
 */
export function getDeviceInfo(): DeviceInfo {
  const ua = navigator.userAgent;
  const isSamsungBrowser = /SamsungBrowser/i.test(ua);
  const isSamsungDevice = /(SM-|Samsung)/i.test(ua);
  const modelMatch = ua.match(/(SM-[A-Za-z0-9]+)/i);
  const model = modelMatch ? modelMatch[1] : '';
  const androidMatch = ua.match(/Android\s([0-9.]+)/);
  const androidVersion = androidMatch ? androidMatch[1] : 'unknown';
  const oneUiMatch = ua.match(/OneUI\/(\d+(?:\.\d+)?)/i);
  const oneUIVersion = oneUiMatch ? oneUiMatch[1] : 'unknown';
  return { isSamsungBrowser, isSamsungDevice, model, androidVersion, oneUIVersion };
}
